export const CSS = {
	container: 'c-AutoCompleteMenu',
	item: 'c-AutoCompleteMenu__Item',
	highlighted: 'c-AutoCompleteMenu--Highlighted',
};

export const Styles = {
	[CSS.highlighted]: {
		'font-weight': 'bold',
	},
};
